import { defaultHttpClient } from 'shared/src/api/httpClient';

type ChangeDefaultAddressParams = {
  default_address_sno: number;
};

/**
 * - 기본 배송지 변경
 * - `PUT /members/me/change_default_address/`
 */
export const changeDefaultAddress = (params: ChangeDefaultAddressParams) => {
  return defaultHttpClient
    .request<void>({
      method: 'PUT',
      url: '/api/v2/members/me/change_default_address/',
      data: params,
    })
    .then(r => r.data);
};
